module.exports = __webpack_public_path__ + "static/media/toastSound.mp3.90a6d5af.mp3";